import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutPageComponent } from './components/layout-page/layout-page.component';
import { AuthGuard } from '../services/auth.guard';
import { AllReformAreasModule } from './all-reform-areas/all-reform-areas.module';
import { ManagementStratgeyModule } from './management-stratgey/management-stratgey.module';
import { SocialImpactModule } from './social-impact/social-impact.module';
import { KnowledgeExpertiseModule } from './knowledge-expertise/knowledge-expertise.module';
import { FinancialModule } from './financial/financial.module';
import { HrModule } from './hr/hr.module';
import { PhysicalInfrastructureModule } from './physical-infrastructure/physical-infrastructure.module';
import { NetworkEcosystemModule } from './network-ecosystem/network-ecosystem.module';
import { ResultOutcomeModule } from './result-outcome/result-outcome.module';
import { BlogsModule } from './menus/blogs/blogs.module';
import { EventsModule } from './menus/events/events.module';
import { GalleryModule } from './menus/gallery/gallery.module';
import { IncubateeModule } from './menus/incubatee/incubatee.module';
import { IncubatorApprovalModule } from './menus/incubator-approval/incubator-approval.module';
import { StartupListComponent } from './menus/startup-list/startup-list.component';
import { NewslettersModule } from './menus/newsletters/newsletters.module';
import { CsrProjectModule } from './menus/CSR-admin-page/csr-project.module';
import { CorporateModule } from './menus/corporate/corporate.module';
import { PreIncubationModule } from './pre-incubation/pre-incubation.module';
import { CoeModule } from './coe/coe.module';
import { Tnimm2PageComponent } from './tnimm2-page/tnimm2-page.component';
// import { PasswordComponent } from './menus/password/password.component';
// import { EventsModule } from './menus/events/events.module';

// import { GalleryModule } from './menus/gallery/gallery.module';
// canActivate: [AuthGuard],
const routes: Routes = [
  {
    path: '',
    component: LayoutPageComponent,
    canActivate: [AuthGuard],
    data: { title: sessionStorage.getItem('role') },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'tnimm2-page' },
      {
        path: 'tnimm2-page',
        component: Tnimm2PageComponent,
        data: { title: 'TNIMM 2.0' },
      },
      {
        path: 'dashboard',
        loadChildren:
          './all-reform-areas/all-reform-areas.module#AllReformAreasModule',
        data: { title: 'Dashboard' },
      },
      {
        path: 'pre-incubation',
        loadChildren:
          './pre-incubation/pre-incubation.module#PreIncubationModule',
        data: { title: 'Pre-Incubation' },
      },
      {
        path: 'coe',
        loadChildren: './coe/coe.module#CoeModule',
        data: { title: 'COE' },
      },
      {
        path: 'management-stratgey',
        loadChildren:
          './management-stratgey/management-stratgey.module#ManagementStratgeyModule',
        data: { title: 'Management Stratgey' },
      },
      {
        path: 'knowledge-expertise',
        loadChildren:
          './knowledge-expertise/knowledge-expertise.module#KnowledgeExpertiseModule',
        data: { title: 'Knowledge Expertise' },
      },
      {
        path: 'social-impact',
        loadChildren: './social-impact/social-impact.module#SocialImpactModule',
        data: { title: 'Social Impact' },
      },
      {
        path: 'financial',
        loadChildren: './financial/financial.module#FinancialModule',
        data: { title: 'Financial' },
      },
      {
        path: 'hr',
        loadChildren: './hr/hr.module#HrModule',
        data: { title: 'Hr' },
      },
      {
        path: 'physical-infrastructure',
        loadChildren:
          './physical-infrastructure/physical-infrastructure.module#PhysicalInfrastructureModule',
        data: { title: 'Physical Infrastructure' },
      },
      {
        path: 'network-ecosystom',
        loadChildren:
          './network-ecosystem/network-ecosystem.module#NetworkEcosystemModule',
        data: { title: 'Network Ecosystem' },
      },
      {
        path: 'result-outcome',
        loadChildren:
          './result-outcome/result-outcome.module#ResultOutcomeModule',
        data: { title: 'Result Outcome' },
      },
      {
        path: 'blog',
        loadChildren: './menus/blogs/blogs.module#BlogsModule',
        data: { title: 'Blog' },
      },
      {
        path: 'event',
        loadChildren: './menus/events/events.module#EventsModule',
        data: { title: 'Event' },
      },
      {
        path: 'corinitiatives',
        loadChildren: './menus/corporate/corporate.module#CorporateModule',
        data: { title: 'Initiatives' },
      },
      {
        path: 'csr',
        loadChildren:
          './menus/CSR-admin-page/csr-project.module#CsrProjectModule',
        data: { title: 'csr-project' },
      },

      {
        path: 'gallery',
        loadChildren: './menus/gallery/gallery.module#GalleryModule',
        data: { title: 'Gallery' },
      },
      {
        path: 'news-letters',
        loadChildren:
          './menus/newsletters/newsletters.module#NewslettersModule',
        data: { title: 'News-Letters' },
      },
      {
        path: 'incubatee',
        loadChildren: './menus/incubatee/incubatee.module#IncubateeModule',
        data: { title: 'incubatee' },
      },
      {
        path: 'approval',
        loadChildren:
          './menus/incubator-approval/incubator-approval.module#IncubatorApprovalModule',
        data: { title: 'Incubator Approval' },
      },
      {
        path: 'startup',
        component: StartupListComponent,
        data: { title: 'Startup' },
      },
      // { path: 'change-password', component: PasswordComponent, data: { title: 'Startup' } }
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    ManagementStratgeyModule,
    SocialImpactModule,
    KnowledgeExpertiseModule,
    FinancialModule,
    HrModule,
    PhysicalInfrastructureModule,
    NetworkEcosystemModule,
    ResultOutcomeModule,
    AllReformAreasModule,
    BlogsModule,
    EventsModule,
    CsrProjectModule,
    GalleryModule,
    NewslettersModule,
    IncubateeModule,
    IncubatorApprovalModule,
    CorporateModule,
    PreIncubationModule,
    CoeModule,
  ],
})
export class AdminRoutingModule { }
